import { ICreateAndUpdateCompany } from "../../../types/company.interface";
import customAxios from "../../customAxios";
import { UPDATE_COMPANY } from "../../routes";

const updateCompany = async (formData: ICreateAndUpdateCompany) => {
  try {
    return (
      await customAxios.put(UPDATE_COMPANY, {
        userId: formData._id,
        address: formData.address,
        lastName: formData.lastName,
        firstName: formData.firstName,
        superAgent: formData.superAgent?._id,
        kartNumber: formData.kartNumber,
        companyName: formData.companyName,
        phoneNumber: formData.phoneNumber,
        shabaNumber: formData.shabaNumber,
        nationalCode: formData.nationalCode,
        city: formData.city,
        province: formData.province,
        isDriverWallet: formData.isDriverWallet,
        isAdminPozMachine: formData.isAdminPozMachine,
        financialGroupSchool: formData.financialGroupSchool,
        nationalCardFront: formData.nationalCardFront?.link,
        nationalCardBack: formData.nationalCardBack?.link,
        companyLicence: formData.companyLicence?.link,
      })
    ).data;
  } catch (error: unknown) {
    console.error({ UPDATE_COMPANY: error });
    return false;
  }
};

export default updateCompany;
